<template>
  <div class="native-table-wrap">
    <table class="native-table">
      <thead>
        <tr>
          <th>ID</th><th>姓名</th><th>职称</th><th>科室</th><th>标签</th>
          <th>首页展示</th><th>类型</th><th>简介</th><th>擅长领域</th><th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in doctorList" :key="row.id">
          <td>{{ row.id }}</td><td>{{ row.name }}</td><td>{{ row.title }}</td>
          <td>{{ row.specialty }}</td><td>{{ row.badge || "-" }}</td>
          <td>{{ row.major === true ? "是" : row.major === false ? "否" : "-" }}</td>
          <td>{{ Number(row.type) === 2 ? "住院" : row.type ? "门诊" : "-" }}</td>
          <td class="truncate" :title="row.experience">{{ row.experience || "-" }}</td>
          <td>
            <template v-if="row.expertiseList?.length">
              {{ row.expertiseList.slice(0, 2).map((item) => item.expertise).join("、") }}
              <span v-if="row.expertiseList.length > 2"> +{{ row.expertiseList.length - 2 }}</span>
            </template>
            <span v-else>-</span>
          </td>
          <td class="actions">
            <NativeButton type="primary" size="small" @click="emit('edit', row)">编辑</NativeButton>
            <NativeButton type="danger" size="small" @click="emit('delete', row)">删除</NativeButton>
          </td>
        </tr>
        <tr v-if="doctorList.length === 0"><td colspan="10" class="empty-cell">暂无数据</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import type { Doctor as DoctorType } from "@/stores/doctors";

defineProps<{ doctorList: DoctorType[] }>();
const emit = defineEmits<{
  (event: "edit", row: DoctorType): void;
  (event: "delete", row: DoctorType): void;
}>();
</script>

<style scoped>
.native-table-wrap { min-width: 0; overflow: auto; }
.native-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
th, td { padding: 10px 12px; border: 1px solid #e2e8f0; text-align: left; vertical-align: top; }
th { position: sticky; top: 0; background: #f8fafc; color: #334155; white-space: nowrap; }
tbody tr:nth-child(even) { background: #fafafa; }
.truncate { max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.actions { display: flex; gap: 6px; }
.empty-cell { padding: 30px; color: #64748b; text-align: center; }
</style>
